import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Box, Stack } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import { Plate, PlateProvider, } from '@udecode/plate';
import { basePlugins } from './WysiwygEditor';
import ToolbarButtons from './config/ToolbarButtons';
import { editableProps } from './config/common/editableProps';
export const EditorToolbar = () => (_jsx(Stack, { direction: "row", alignItems: "center", sx: {
        color: '#444444',
        backgroundColor: 'white',
        width: '100%',
    }, children: _jsx(ToolbarButtons, {}) }));
const getSxProp = (store) => {
    const sxprop = {};
    if (store.currentPortal?.stylesheet?.style?.sections) {
        const i = store.currentPortal?.stylesheet?.style?.sections.findIndex((s) => s.id === 'site');
        if (store.currentPortal?.stylesheet?.style?.sections[i].properties) {
            const f = store.currentPortal?.stylesheet?.style?.sections[i].properties.findIndex((p) => p.id === 'font');
            if (f > -1) {
                if (store.currentPortal?.stylesheet?.style?.sections[i].properties[f]?.value?.fontFamily) {
                    // eslint-disable-next-line max-len
                    sxprop.fontFamily = store.currentPortal?.stylesheet?.style?.sections[i].properties[f]?.value?.fontFamily;
                }
            }
        }
    }
    return sxprop;
};
const WysiwygProvider = ({ id, value, setValue, children, }) => {
    const store = useStore();
    // console.log('provider', {
    //   id,
    //   value,
    //   setValue,
    // });
    const plateId = `ipe-${id}`;
    return (_jsx(Box, { sx: {
            ...getSxProp(store),
        }, children: _jsx(PlateProvider, { id: plateId, initialValue: value, plugins: basePlugins, onChange: setValue, children: children }) }));
};
const WysiwygInPlaceEditor = ({ id, }) => {
    const store = useStore();
    const containerRef = useRef(null);
    const plateId = `ipe-${id}`;
    return (_jsx(Box, { sx: {
            '& [data-slate-editor]': {
                padding: 0,
            },
            ...getSxProp(store),
        }, onMouseDown: () => store.setInWysiwygEditorSelect(true), onMouseUp: () => store.setInWysiwygEditorSelect(false), onClick: (event) => {
            console.log('IPE stop click event');
            event.stopPropagation();
        }, ref: containerRef, children: _jsx(Plate, { editableProps: editableProps, id: plateId }) }));
};
export { WysiwygProvider, WysiwygInPlaceEditor };
//# sourceMappingURL=WysiwygInPlaceEditor.js.map